$shm_hitalama_map_widget_float_notebook2_adds $mol_view
	Map_page $shm_hitalama_map_page
	Notebook $shm_hitalama_map_widget_float_notebook2
	sub <= add_lines /
	Add_line* $shm_hitalama_map_widget_float_notebook2_adds_line
		Map_page <= Map_page
		add_types <= add_types /
			\text_md
			\code_js
			\iframe
		showed <= add_line_showed* false
		left_px <= add_line_left_px* \0px
		top_px <= add_line_top_px* \0px
		real_pos <= add_line_real_pos* /
			0
			0
